import axios from 'axios'
const endpoint = process.env.VUE_APP_BASE_API + '/api/master/depositRefunds'

export default {
  async getAllDemands(filter) {
    return await axios
      .get(endpoint + `/list/demanded${filter}`)
      .then(response => {
        return response.data
      });
  },
  async getAllCanceled(filter) {
    return await axios
      .get(endpoint + `/list/canceled${filter}`)
      .then(response => {
        return response.data
      });
  },
  async getAllApproved(filter) {
    return await axios
      .get(endpoint + `/list/approved${filter}`)
      .then(response => {
        return response.data
      });
  },
  async getAllRejected(filter) {
    return await axios
      .get(endpoint + `/list/rejected${filter}`)
      .then(response => {
        return response.data
      });
  },
  async viewAttachment(id) {
    return await axios
      .get(endpoint + `/item/attach/${id}`)
      .then(response => {
        return response.data
      });
  },
  async attach(request) {
    return await axios
      .post(endpoint + '/attach', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async demand(request) {
    return await axios
      .post(endpoint + '/demanded', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async approve(request) {
    return await axios
      .post(endpoint + '/approved', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async reject(request) {
    return await axios
      .put(endpoint + '/rejected', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async cancel(request) {
    return await axios
      .put(endpoint + '/canceled', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
}



// WEBPACK FOOTER //
// ./src/services/master/deposit/depositRefundService.js